import { pick } from 'lodash';
import type { SagaReturnType } from 'redux-saga/effects';
import { call, put, select, takeEvery } from 'redux-saga/effects';
import { api } from 'src/api';
import { logger } from 'src/error';
import { CONFIRM_CLIENT } from 'src/routes/Checkout/store/constants/order';
import { VALIDATE_TOURIST_ON_SERVER } from 'src/routes/Checkout/store/constants/tourists';
import { validateTourist } from 'src/routes/Checkout/store/domains/tourists-checkout-validation/saga';
import {
  addValidation,
  clearValidations,
  setValidationInProgress,
} from 'src/routes/Checkout/store/domains/tourists-checkout-validation/slice';
import { getInsuranceType } from 'src/routes/Checkout/store/selectors/order';
import { getPackageId } from 'src/routes/Checkout/store/selectors/package';
import { touristsSelector } from 'src/store/tourists/selectors';

const pickTourist = (tourist) =>
  pick(tourist || {}, [
    'gender',
    'name',
    'surname',
    'patronymic',
    'birthday',
    'passport_number',
    'passport_expires_on',
    'visa_service',
    'nationality_id',
  ]);

export function* validateAllTourists(tourists) {
  if (tourists?.length) {
    yield put(clearValidations());

    const packageId = yield select(getPackageId);

    yield put(setValidationInProgress(true));

    const touristsToValid = tourists.filter((t) => !t.hideDocInputs);
    let hasUnvalids = false;

    try {
      for (let i = 0; i < touristsToValid.length; i += 1) {
        const tourist = pickTourist(touristsToValid[i]);

        const params = {
          package_id: packageId,
          tourist,
          flight_pair_id: '',
        };
        const paramsHotel = {
          package_id: packageId,
          tourists,
        };
        const insuranceType: SagaReturnType<typeof getInsuranceType> =
          yield select(getInsuranceType);
        const response = !insuranceType
          ? yield api.postTouristsHotelValidate(paramsHotel)
          : yield api.postTouristsValidate(params);

        const passportNumber = tourist.passport_number;

        const validation = {
          passportNumber,
          validation: response,
        };

        if (Boolean(response.errors) || Boolean(response.custom_errors)) {
          hasUnvalids = true;
        }

        if (passportNumber) {
          yield put(addValidation(validation));
        }

        yield put(addValidation(validation));
      }
    } catch (error) {
      logger(error, 'Validate All Tourists');
    }

    yield put(setValidationInProgress(false));

    if (hasUnvalids) {
      throw new Error('Tourists are not valid!');
    }
  }
}

function* handleClear() {
  yield put(clearValidations());
}

function* handleValidateTouristOnServer(action) {
  const index = action?.payload;

  const tourists = yield select(touristsSelector);
  const tourist = pickTourist(tourists[index]);
  const insuranceType: SagaReturnType<typeof getInsuranceType> = yield select(
    getInsuranceType,
  );
  if (!insuranceType) yield call(validateTourist, tourist);
}

function* saga() {
  yield takeEvery(CONFIRM_CLIENT, handleClear);
  yield takeEvery(VALIDATE_TOURIST_ON_SERVER, handleValidateTouristOnServer);
}

export default saga;
